import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { createMigrate, FLUSH, PAUSE, PERSIST, persistReducer, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import cartReducer from './reducers/cartSlice';
import configReducer from './reducers/configSlice';

const persistConfig = {
  key: 'widget',
  migrate: createMigrate(
    {
      1: (state: any) => ({ ...state, cart: { products: [] } }),
    },
    { debug: false },
  ),
  storage,
  version: 1,
  writeFailHandler: (err: Error) => console.warn('[redux-persist] write failed', err),
};

const reducers = combineReducers({
  cart: cartReducer,
  config: configReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  reducer: persistedReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
